import React from "react";
import Modal from "react-responsive-modal";
import DOMPurify from 'dompurify';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import FacebookLogin from "react-facebook-login";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useGoogleLogin  } from "@react-oauth/google";
import * as constand from "../../constant";
import {
  loginModelOpen,
  forgotModelOpen,
  login,
  logout,
  facebookLogin,
  googleLogin,
  isAuth,
  start_loader,
  stop_loader,
  fetchUserDetails,
  packsterGotoRegister,
  fetchNotifications,
  updateUserChallengeTag,
  healthCondition,
  getFooter,
  getFeatures,
  setExploreConditions,
  openPolicy,
  openClinic,
  getClinic,
  masterUserDetails,
  fetchUserOtherDetails,
  openAccountLockedPopup,
  getConditionBanner
} from "../../actions";
import { toast } from "react-toastify";
import { Cookies } from "react-cookie-consent";
import { commonService } from "../../_services";
import ConfirmationPopup from "../Common/ConfirmationPopup";
import axios from "axios";

class LoginComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      submitted: false,
      loading: false,
      redirect_open: false,
      error: "",
      isTermPopupOpen: false,
      passwordAttempts: null,
      passwordRemaining: null,
      isShowPassword: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.loginSubmit = this.loginSubmit.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.closeModel = this.closeModel.bind(this);
    this.facebookResponse = this.facebookResponse.bind(this);
    this.cleatState = this.cleatState.bind(this);
    this.getUserDetail = this.getUserDetail.bind(this);
    this.redirectCloseModel = this.redirectCloseModel.bind(this);
    this.redirectOpenModel = this.redirectOpenModel.bind(this);
    this.forgotPassword = this.forgotPassword.bind(this);
    this.openClinicPopup = this.openClinicPopup.bind(this);
  }

  facebookResponse = e => {

    //console.log('loinfb',e)
    //this.props.facebookLogin(e);
    this.props.facebookLogin(e).then(
      response => {
        this.socialMediaLoginDetails(response, e, 'facebook');
      },
      error => {
        this.closeModel();
        toast.error(error);
      }
    );
  };

  socialMediaLoginDetails(response, eResponse , socialType){
    if (response.isPactsterUser && response.userid) //pacsterUsers
    {
      this.closeModel();
      this.setState({ error: "", loading: false, redirect_open: true });
      var userid = response.userid;
      var membershipObj = response.membership;
      if(socialType=='facebook'){
        this.props.packsterGotoRegister(userid, membershipObj, eResponse, null);
      }
      else{
        this.props.packsterGotoRegister(userid, membershipObj, null, eResponse);
      }
      const { from } = { from: { pathname: "/register" } };
      this.props.history.push(from);
    } else { //newUsers
      this.props.isAuth();
      this.closeModel();
      toast.success(response.message);
      this.getUserDetail();
    }
  }

  handleChange(
    e //for twoway binding
  ) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }
  cleatState() {
    this.setState({
      username: "",
      password: "",
      submitted: false,
      loading: false,
      error: ""
    });
  }

  onCloseModal() { }

  forgotPassword() {
    this.props.loginModelOpen(false);
    this.props.forgotModelOpen(true);
  }

  closeModel() { //for close the login model
    this.cleatState();
    this.props.loginModelOpen(false);
    if (JSON.parse(sessionStorage.getItem("userPasswordAttempts"))) {
      setTimeout(() => {
        sessionStorage.removeItem("userPasswordAttempts")
        this.setState({ passwordAttempts: null, passwordRemaining: 5 })
      }, 60000 * 5)  // 5 minutes call
    }
  }

  redirectOpenModel() { //redirect model open
    this.setState({ redirect_open: true });
  }

  redirectCloseModel() { //redirect close model
    this.setState({ redirect_open: false });
  }

  loginSubmit(e) { //for submit login
    e.preventDefault();
    this.setState({ submitted: true });
    const { username, password } = this.state;

    // stop here if form is invalid
    if (!(username && password)) {
      return;
    }
    // Validate if the username is a proper email and the domain extension does not contain numbers
    const emailPattern = /^[^\s@]+@[^\s@]+\.[a-zA-Z]+$/;
    if (!emailPattern.test(username)) {
      this.setState({ error: "Please enter a valid email address." });
      return;
    }

    this.setState({ loading: true });
    let email = username;
    this.props.login(email, password).then(
      response => {
        if (response && response.isAccountLocked) {
          let attemptArray = sessionStorage.getItem("userPasswordAttempts") && !undefined ? JSON.parse(sessionStorage.getItem("userPasswordAttempts")) : {};
          attemptArray[username] = 0;
          sessionStorage.setItem("userPasswordAttempts", JSON.stringify(attemptArray));
          this.props.openAccountLockedPopup(true)
          this.closeModel();
          this.props.logout();
        } else if (!response.passwordErr) {
          if (response.isPactsterUser && response.userid) //pacsterUsers
          {
            this.closeModel();
            this.setState({ error: "", loading: false, redirect_open: true });
            let userid = response.userid;
            let membershipObj = response.membership;
            this.props.packsterGotoRegister(userid, membershipObj);
            const { from } = { from: { pathname: "/register" } };
            this.props.history.push(from);
          } else { //newUsers
            this.setState({ error: "" });
            this.props.isAuth();
            this.closeModel();
            toast.success(response.message);
            this.getUserDetail();
            sessionStorage.removeItem("userPasswordAttempts");
            sessionStorage.setItem("loggedInFromOnDemand", true)
          }
        } else {
          //to check account is locked or not
          this.lockedAccountCheck(response);
        }
      },
      error => {
        this.setState({ error: error, loading: false });
      }
    );
  }

  lockedAccountCheck = (response) => {
    if (response.passwordErr) {
      this.props.logout();
      const { username, password } = this.state;
      let userPasswordAttempts = JSON.parse(sessionStorage.getItem("userPasswordAttempts"))
      let attemptArray = userPasswordAttempts && userPasswordAttempts != null ? userPasswordAttempts : {};
      attemptArray[username] = attemptArray != undefined && attemptArray[username] ? attemptArray[username] + 1 : 1;
      this.setState({ passwordAttempts: attemptArray[username], passwordRemaining: 5 - attemptArray[username] });
      sessionStorage.setItem("userPasswordAttempts", JSON.stringify(attemptArray));
      if (attemptArray[username] >= 5) {
        this.props.login(username, password, true).then((res) => {
          if (res) {
            attemptArray[username] = 0;
            sessionStorage.setItem("userPasswordAttempts", JSON.stringify(attemptArray));
            this.props.openAccountLockedPopup(true)
            this.closeModel();
          }
        });
      } else if (response.isAccountLocked && response.passwordErr) {
        sessionStorage.removeItem("userPasswordAttempts")
        this.setState({ passwordAttempts: null, passwordRemaining: 5 })
        this.props.openAccountLockedPopup(true)
        this.closeModel();
      }
      this.setState({ error: response.message, loading: false });
    }
  }

  getUserDetail() {
    //this.props.history.push(from);
    this.props.start_loader();
    this.props.fetchUserDetails().then(
      response => {
        this.props.masterUserDetails(this.props.logged_userData)
        this.props.fetchUserOtherDetails().then(() => {
          sessionStorage.setItem('masterUserDetails', JSON.stringify(this.props.logged_userData))
        })
        this.props.healthCondition();
        this.props.fetchNotifications();
        this.props.setExploreConditions(this.props.logged_userData.UserConditions, this.props.healthcondition_list)
        //open kidney clinic popup when login first time
        var kd_condition = this.props.logged_userData.UserConditions && this.props.logged_userData.UserConditions.find(element => element.Tag && element.Tag.tag == constand.KR_CONDITION);
        var countryId = this.props.logged_userData.Country && this.props.logged_userData.Country.id
        this.openClinicPopup(kd_condition, countryId);
        this.props.stop_loader();
        var locationHistory = JSON.parse(sessionStorage.getItem("locationHistory"))
        var programHistory = JSON.parse(sessionStorage.getItem("programHistory"))
        if (this.props.init_condition) {
          if (this.props.logged_userData.isStudyUser) {
            var community = this.props.logged_userData.Members.length ? this.props.logged_userData.Members[0].Community.community_name : '';
            var pathname_data = community ? '/group/feed/' + community + '/' + this.props.init_condition : '/groups/' + this.props.init_condition;
          } else if ((this.props.logged_userData.isGroupLeader || this.props.logged_userData.isStudyLeader || this.props.logged_userData.isStudyInstructor) && constand.SL_MENU.includes('on-demand')) {
            var url = '/on-demand/';
            var pathname_data = url + this.props.init_condition;
          } else if (locationHistory) {
            var pathname_data = locationHistory;
            sessionStorage.removeItem("locationHistory");
          } else {
            var url = '/liveClasses/';
            var pathname_data = url + this.props.init_condition;
          }
          this.props.getFooter(commonService.replaceChar(this.props.init_condition, true))
          this.props.getFeatures();
          this.props.getConditionBanner(commonService.replaceChar(this.props.init_condition, true))
          if (programHistory) {
            var pathname_data = programHistory;
            sessionStorage.removeItem("programHistory");
          }
          const { from } = { from: { pathname: pathname_data } };
          this.props.history.push(from);

          setTimeout(() => {
            var temp = commonService.returnTagName('condition', constand.KR_CONDITION, this.props.logged_userData.UserConditions);
            if (sessionStorage.getItem('beamchallenging') && this.props.is_auth && temp) {
              this.props.updateUserChallengeTag();
            }
          }, 1000)
          //open policy popup
          if (!this.props.logged_userData.terms) {
            this.props.openPolicy(true);
          }


        }
      },
      error => {
        this.props.stop_loader();
        toast.error(error);
      }
    );
  }
  //kd clinic popup open
  async openClinicPopup(kd_condition, countryId) {
    if (kd_condition && kd_condition.conditionId)
      await this.props.getClinic(countryId, kd_condition.conditionId);
    if (!this.props.logged_userData.isClinicResponse && kd_condition && !kd_condition.clinicId && this.props.clinic_list && this.props.clinic_list.length > 0) {
      //get clinic for Kidney popup
      this.props.openClinic(true);
    }
  }

  closeAccountLockPopup = () => {
    this.props.openAccountLockedPopup(false)
    this.setState({ error: "" })
  }

  componentDidMount() {
    // password attempts clear
    setTimeout(() => {
      sessionStorage.removeItem("userPasswordAttempts")
      this.setState({ passwordAttempts: null, passwordRemaining: 5 })
    }, 60000 * 5)  // 5 minutes call
  }

  showHidePassword = () => {
    this.setState({ isShowPassword: !this.state.isShowPassword })
  }

  render() {
    const { username, password, submitted, loading, error } = this.state;
    return (
      <React.Fragment>
        <Modal
          className="removebbg-popup"
          open={this.props.is_model_open && !this.props.is_auth}
          onClose={this.onCloseModal}
          center
        >
          <div className="modal-dialog modal-width--custom m-t-80" role="document">
            <div className="modal-content">
              <div className="modal-header header-styling  border-0">
                <h5
                  className="modal-title text-center col-md-11 p-0 font-semibold"
                  id="exampleModalLabel font-medium"
                >
                  Login to Kidney Beam
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" onClick={this.closeModel}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body body-padding--value pb-0">
                <form name="login" onSubmit={this.loginSubmit}>
                  <div
                    className={
                      "form-group" +
                      (submitted && !username ? " has-error" : "")
                    }
                  >
                    <label
                      htmlFor="exampleInputEmail1"
                      className="font-14 font-qregular black-txt"
                    >
                      Email
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="username"
                      aria-describedby="emailHelp"
                      placeholder=""
                      name="username"
                      value={username}
                      onChange={this.handleChange}
                    />
                    {submitted && !username && (
                      <div className="text-danger">Username is required</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="exampleInputEmail1"
                      className="font-14 font-qregular black-txt"
                    >
                      Password
                    </label>
                    <div className="passwordeye_align">                    
                      <input
                        type={this.state.isShowPassword ? "text" : "password"} 
                        id="password"
                        className="form-control"
                        aria-describedby="emailHelp"
                        placeholder=""
                        name="password"
                        value={password}
                        onChange={this.handleChange}
                      />
                      <div class="input-group-addon">
                        <button type="button" onClick={() => this.showHidePassword()} >
                            <i class={this.state.isShowPassword ? "fa fa-eye" : "fa fa-eye-slash"} aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                    {submitted && !password && (
                      <div className="text-danger">Password is required</div>
                    )}
                  </div>
                  <div className="text-center form-group">
                  {error && (
                      <span
                        className="text-danger error-password"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(error, {
                          ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|ftp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
                        }) }}
                      />
                    )}
                    {error && this.state.passwordAttempts && <p className="text-danger">{this.state.passwordAttempts} attempts remaining {this.state.passwordRemaining}</p>}
                  </div>
                  <div className="text-center form-group m-t-20 m-b-20">
                    <span className="col-md-12 p-0 text-underline pointer font-14 font-qregular black-txt">
                      <u onClick={this.forgotPassword}>I forgot my password</u>
                    </span>
                  </div>
                  <div className="col-md-12 text-center p-0">
                    <button
                      disabled={loading}
                      type="submit"
                      className=" btn btn-block mybtn btn-login tx-tfm font-book font-14"
                    >
                      Login
                    </button>
                  </div>
                </form>

                  <div className="col-md-12 ">
                    <div className="login-or text-center">
                      <span className="span-or text-uppercase">or</span>
                    </div>
                  </div>
                  <div className="col-md-12 mb-4 p-0">
                    <p className="text-center">
                      <FacebookLogin
                        version="19.0"
                        appId={constand.FACEBOOK_APP_KEY}
                        disableMobileRedirect={true}
                        autoLoad={false}
                        fields="name,email,picture"
                        callback={this.facebookResponse}
                        cssClass="google btn btn-lg btn-facebook font-book font-14 mybtn"
                        icon="fa fa-facebook-square"
                      />
                    </p>
                  </div>
                  <div className="col-md-12 mb-3 p-0">
                    <p className="text-center">
                      <GoogleOAuthProvider clientId={constand.GOOGLE_CLIENT_ID}>
                        <GoogleLoginComponent onGoogleLogin = {this.props.googleLogin} onSocialMediaLoginDetails = {this.socialMediaLoginDetails.bind(this)} onCloseModel = {this.closeModel.bind(this)} />
                      </GoogleOAuthProvider>
                    </p>
                  </div>

                  <div className="form-group">
                    <p className="text-center signup-here font-qmedium font-14 m-b-30">
                      Not got an account?{" "}
                      <Link
                        to="/register"
                        className="signup-here--text font-qmedium font-14"
                        id="signup"
                      >
                        Sign up here
                      </Link>
                    </p>
                  </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className="removebbg-popup"
          open={this.state.redirect_open}
          onClose={this.onCloseModal}
          center
        >
          <div
            className="modal-dialog schedule_block start-popup common_design modal-width--custom"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header header-styling  border-0">
                <h5
                  className="modal-title1 text-center col-md-12 p-0  font-semibold  white-txt"
                  id="exampleModalLabel "
                >
                  Hold your horses
                </h5>

                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" onClick={this.redirectCloseModel}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body pb-0">
                <h5 className="pop-sub-head black-txt text-center font-15 m-t-20 font-normal font-book m-b-20 ">
                  Welcome to Kidney Beam!
                </h5>
                <p className="font-book black-txt text-center mx-auto w-75 font-15 font-normal">
                  We are super excited to have launched our new website but
                  we're still working on migrating your info across from
                  Pactster's website.
                </p>
                <br />
                <p className="font-book black-txt text-center mx-auto w-75 font-15 font-normal">
                  In the meantime feel free to take a look around our new site
                  but to log in and use your account we're going to have to ask
                  you to continue to use Pactster.
                </p>
                <br />
                <p className="font-book black-txt text-center mx-auto w-75 font-15 font-normal">
                  We'll be in touch as soon as we're all sorted here to invite
                  you to start using Kidney Beam.
                </p>
                <a
                  className="btn btn-login popup-btn w-75 mx-auto m-t-20 m-b-20"
                  href={constand.LOGIN_REDIRECTION_URL}
                >
                  {" "}
                  Take me back to Pactster{" "}
                </a>
              </div>
            </div>
          </div>
        </Modal>
        {this.props.is_account_locked && <ConfirmationPopup
          is_model_open={this.props.is_account_locked}
          type='accountLocked'
          isCloseRequired={true}
          title="Whoops! Your account has been locked."
          hasButton={false}
          closePopup={() => this.closeAccountLockPopup()}
        />
        }
      </React.Fragment>
    );
  }
}

function  GoogleLoginComponent(props){
  const onSuccess = async (successResponse) => {
    const googleUser = await axios
    .get('https://www.googleapis.com/oauth2/v3/userinfo', {
      headers: { Authorization: `Bearer ${successResponse.access_token}` },
    })
    .then(res => res.data);

    props.onGoogleLogin(googleUser).then(
      response => {
        props.onSocialMediaLoginDetails(response, googleUser, 'google');
      },
      error => {
        props.onCloseModel();
        toast.error(error);
      }
    );
  }

  const login = useGoogleLogin({
    onSuccess: onSuccess
  });

  return <button onClick={login} className="google btn btn-lg btn-google font-book font-14 mybtn"><i className="fa fa-google" aria-hidden="true"></i><span className="signup-text">Login with Google</span></button>
}

const mapStateToProps = state => {
  return {
    is_auth: state.auth.is_auth,
    is_model_open: state.header.is_loginModelOpen,
    init_condition: state.auth.initial_condition,
    logged_userData: state.header.logged_userData,
    healthcondition_list: state.register.healthcondition_list,
    clinic_list: state.register.clinic_list,
    is_account_locked: state.accountinfo.is_account_locked
  };
};

const mapDispatchToProps = {
  loginModelOpen,
  forgotModelOpen,
  login,
  logout,
  isAuth,
  facebookLogin,
  googleLogin,
  start_loader,
  stop_loader,
  fetchUserDetails,
  packsterGotoRegister,
  fetchNotifications,
  updateUserChallengeTag,
  healthCondition,
  getFooter,
  getFeatures,
  setExploreConditions,
  openPolicy,
  openClinic,
  getClinic,
  masterUserDetails,
  fetchUserOtherDetails,
  openAccountLockedPopup,
  getConditionBanner
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginComponent);
